import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    component: () => import("@/layouts/BlankLayout.vue"),
    children: [
      {
        path: "/",
        name: "login",
        component: () => import("@/views/LoginView.vue"),
      },
      {
        path: "team-registration",
        name: "TeamRegistration",
        component: () => import("@/views/TeamRegistrationFromView.vue"),
      },
      {
        path: "operational-data-recording",
        name: "OperationalForm",
        component: () => import("@/views/OperationalFromView.vue"),
      },
    ],
  },
  {
    path: "",
    component: () => import("@/layouts/DefaultLayout.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/DashboardView.vue"),
      },
      {
        path: "dashboard/team-registration/:id",
        name: "TeamRegistrationDetails",
        component: () => import("@/views/TeamRegistrationDetailsView.vue"),
        props: (route) => ({
          mode: route.query.mode || "views",
        }),
      },
      {
        path: "dashboard/operational-data-recording/:id",
        name: "OperationalDataRecordingDetails",
        component: () => import("@/views/OperationalDataRecordingDetails.vue"),
        props: (route) => ({
          mode: route.query.mode || "views",
        }),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isAuthenticated;

  if (to.matched.some((record) => record.meta.requiresAuth) && !isLoggedIn) {
    if (to.name !== "login") next({ name: "login" });
    else next();
    return;
  }

  if (to.name === "login" && isLoggedIn) {
    if (from.name !== "Dashboard") next({ name: "Dashboard" });
    else next();
    return;
  }

  next();
});

export default router;
